import React, { useState } from "react"
import { ScrollView, View, Linking } from "react-native"
import styles from "./styles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"
import { TouchableOpacity } from "react-native"

const BibliographySources = (props) => {
    const openLink = (url) => Linking.openURL(url).catch((err) => console.error("Couldn't load page", err))

    const urls = [
        {
            url: "https://www.has-sante.fr/"
        },

        {
            url: "https://www.hcsp.fr/explore.cgi/Accueil"
        },

        {
            url: "https://www.ameli.fr/"
        },

        {
            url: "https://sante.gouv.fr/prevention-en-sante/preserver-sa-sante/le-programme-national-nutrition-sante/article/programme-national-nutrition-sante-pnns-professionnels"
        },

        {
            url: "https://www.inserm.fr/"
        },

        {
            url: "https://www.e-cancer.fr/"
        },

        {
            url: "https://www.who.int/fr"
        },

        {
            url: "https://ansm.sante.fr/"
        },

        {
            url: "https://base-donnees-publique.medicaments.gouv.fr/"
        }
    ]

    return (
        <View style={styles.container}>
            <ScrollView
                keyboardShouldPersistTaps={"handled"}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 100 }}
            >
                <View style={styles.header}>
                    <BreeSerifText style={styles.title}>Sources : </BreeSerifText>
                </View>

                {urls.map((item, index) => (
                    <TouchableOpacity onPress={() => openLink(item.url)} key={index} style={styles.item}>
                        <BreeSerifText fontSize={RFValue(12)} style={styles.contentTitle}>
                            {item.url}
                        </BreeSerifText>
                    </TouchableOpacity>
                ))}
            </ScrollView>
        </View>
    )
}

export default BibliographySources
